export const featureToggles = {
  ENABLE_JOULE: 'enableJoule',
  ENABLE_ANALYTICS_TEST: 'enableAnalyticsTest',
  ENABLE_RAG_CHAT: 'enableRagChat',
} as const;
